import script from "./PriceRangeFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceRangeFilter.vue?vue&type=script&setup=true&lang=ts"

import "./PriceRangeFilter.vue?vue&type=style&index=0&id=9f2b8528&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f2b8528"]])

export default __exports__